// extracted by css-extract-rspack-plugin
export default {"section":"Card-module__section___lTEEE"};